import type {
    TextStyle
} from "react-native";
import type {
    OptionRowHighlightDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const OPTION_ROW_HIGHLIGHT_VARIANT: keyof NCoreUIKit.Typography = "titleSmallSize";

export const useStyles = ({
    typography
}: OptionRowHighlightDynamicStyleType) => {
    const currentTypography = typography[OPTION_ROW_HIGHLIGHT_VARIANT];

    const styles = {
        highlight: {
            fontFamily: currentTypography.fontFamily,
            fontWeight: currentTypography.fontWeight
        } as Mutable<TextStyle>
    };

    return styles;
};
